import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const navigate = useNavigate();

  async function login(e) {
    e.preventDefault();

    try {
      await signInWithEmailAndPassword(auth, email, senha);
      navigate("/admin-exportar");
    } catch {
      alert("Login inválido");
    }
  }

  return (
    <div className="page">
      <div className="card">
        <h1>Login Administrativo</h1>

        <form onSubmit={login}>
          <label>Email</label>
          <input value={email} onChange={e => setEmail(e.target.value)} />

          <label>Senha</label>
          <input type="password" value={senha} onChange={e => setSenha(e.target.value)} />

          <button>Entrar</button>
        </form>
      </div>
    </div>
  );
}
